(() => {
  const SELECTOR = '[data-featured-products-section]';
  const MOBILE_QUERY = '(max-width: 749px)';

  function initializeSection(section) {
    if (!section || section.dataset.productsSliderInitialized === 'true') {
      return;
    }

    const track = section.querySelector('[data-products-track]');
    const slides = Array.from(
      section.querySelectorAll('[data-product-slide]')
    );
    const previousButton = section.querySelector(
      '[data-products-previous]'
    );
    const nextButton = section.querySelector('[data-products-next]');
    const currentCounter = section.querySelector(
      '[data-products-current]'
    );

    if (
      !track ||
      slides.length < 2 ||
      !previousButton ||
      !nextButton ||
      !currentCounter
    ) {
      return;
    }

    section.dataset.productsSliderInitialized = 'true';

    const mobileMedia = window.matchMedia(MOBILE_QUERY);
    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    let activeIndex = 0;
    let scrollTimer = null;
    let resizeTimer = null;

    function sliderIsActive() {
      return (
        mobileMedia.matches &&
        section.classList.contains(
          'lekonas-featured-products--mobile-slider'
        )
      );
    }

    function getMaximumScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function getSlidePosition(index) {
      const slide = slides[index];

      if (!slide) {
        return 0;
      }

      return Math.min(slide.offsetLeft, getMaximumScroll());
    }

    function getClosestSlideIndex() {
      const currentScroll = track.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const position = Math.min(
          slide.offsetLeft,
          getMaximumScroll()
        );
        const distance = Math.abs(position - currentScroll);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function updateControls() {
      currentCounter.textContent = String(activeIndex + 1);

      const maximumScroll = getMaximumScroll();
      const isAtStart = track.scrollLeft <= 2;
      const isAtEnd =
        track.scrollLeft >= maximumScroll - 2 ||
        activeIndex >= slides.length - 1;

      previousButton.disabled = isAtStart || activeIndex <= 0;
      nextButton.disabled = isAtEnd;

      previousButton.setAttribute(
        'aria-disabled',
        previousButton.disabled ? 'true' : 'false'
      );
      nextButton.setAttribute(
        'aria-disabled',
        nextButton.disabled ? 'true' : 'false'
      );
    }

    function scrollToIndex(index) {
      if (!sliderIsActive()) {
        return;
      }

      activeIndex = Math.max(
        0,
        Math.min(index, slides.length - 1)
      );

      track.scrollTo({
        left: getSlidePosition(activeIndex),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });

      updateControls();
    }

    function handleScroll() {
      window.clearTimeout(scrollTimer);

      scrollTimer = window.setTimeout(() => {
        activeIndex = getClosestSlideIndex();
        updateControls();
      }, 90);
    }

    function handleResize() {
      window.clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(() => {
        if (!sliderIsActive()) {
          activeIndex = 0;
          previousButton.disabled = true;
          nextButton.disabled = false;
          currentCounter.textContent = '1';
          return;
        }

        scrollToIndex(activeIndex);
      }, 150);
    }

    function handlePreviousClick() {
      scrollToIndex(activeIndex - 1);
    }

    function handleNextClick() {
      scrollToIndex(activeIndex + 1);
    }

    previousButton.addEventListener(
      'click',
      handlePreviousClick
    );
    nextButton.addEventListener('click', handleNextClick);

    track.addEventListener('scroll', handleScroll, {
      passive: true
    });

    window.addEventListener('resize', handleResize);

    if (typeof mobileMedia.addEventListener === 'function') {
      mobileMedia.addEventListener('change', handleResize);
    } else if (typeof mobileMedia.addListener === 'function') {
      mobileMedia.addListener(handleResize);
    }

    activeIndex = getClosestSlideIndex();
    updateControls();
  }

  function initializeAllSections(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(initializeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAllSections();
    });
  } else {
    initializeAllSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllSections(event.target);
  });

  document.addEventListener('shopify:section:reorder', () => {
    initializeAllSections();
  });
})();